<template>
    <v-card :loading="loading">
        <v-card-title class="text-h5">Update Package</v-card-title>
        <v-divider class="ml-4 mr-5 mb-2" />
        <v-card-text>
            <v-form v-model="valid">
                <v-text-field
                    v-model="crateMass"
                    label="Crate Mass"
                    type="number"
                    :rules="[rules.number, rules.required]"
                    suffix="Kg"
                />
            </v-form>
        </v-card-text>
        <v-card-actions class="pb-3 pt-0">
            <v-btn text color="secondary" @click="close">
                Close
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                @click="updateParams"
                :loading="loading"
                rounded
                :disabled="
                    !valid ||
                        +this.packageElement.packageDimensions.mass ==
                            this.crateMass
                "
            >
                Save
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import API from '@/services/api'

export default {
    name: 'UpdatePackageParams',
    props: {
        packageElement: {
            type: Object,
            required: true,
        },
        packingListId: {
            type: String,
            required: true,
        },
        projectId: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        valid: false,
        loading: false,
        crateMass: 0,
        rules: {
            required: v => !!v || 'Required',
            number: v => (!isNaN(v) && v >= 0) || 'Invalid number',
        },
    }),
    async mounted() {
        this.crateMass = this.packageElement.packageDimensions.mass
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        close() {
            this.$emit('closeDialog', {})
        },
        async updateParams() {
            try {
                this.loading = true
                await API.updatePackageParams({
                    projectId: this.projectId,
                    packingListId: this.packingListId,
                    packageId: this.packageElement.id,
                    params: {
                        mass: +this.crateMass,
                    },
                })
                this.packageElement.packageDimensions.mass = this.crateMass
                this.$emit('closeDialog', {
                    packageDimensions: this.packageElement.packageDimensions,
                })
            } catch (error) {
                console.log(error)
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<style>
#virtual-scroll-table {
    width: 100%;
    overflow: auto;
}
.v-data-table {
    border: 1px solid #eeeeee;
}
</style>
